import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Parcels from './Parcels';

const ParcelsViewer: React.FC = (): any => (
  <div style={{ width: '100%', height: '100%' }}>
    <Routes>
      <Route
        path='/'
        element={<Parcels />}
      />
    </Routes>
  </div>
);

export default ParcelsViewer;
